import Component from 'react-pure-render/component';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';

export default class PatrimonioTipoDominioTable extends Component {
  static propTypes = {
    tiposDominios: PropTypes.object.isRequired
  };

  render() {
    const { tiposDominios } = this.props;

    if (tiposDominios.isEmpty()) return null;

    return (
      <Panel
        isTable
        tableResponsive
        expansible={false}
        title="Tipos de domínio do imóvel"
      >
        <div className="panel-table-outer">
          <table className="panel-table striped fancy">
            <TableHeader empty={tiposDominios.isEmpty()}>
              <tr>
                <th>Tipo</th>
                <th>Data</th>
                <th>Pessoa</th>
                <th>Descrição</th>
                <th>Ínicio</th>
                <th>Termino</th>
                <th>Tipo Contrato</th>
                <th>Número Contrato</th>
                <th>Ano Contrato</th>
              </tr>
            </TableHeader>
            <tbody>
              {tiposDominios.map((tipo, index) => (
                <tr key={index}>
                  <td>{tipo.get('tipo')}</td>
                  <td>{DateUtils.formatDateTimeShort(tipo.get('data'))}</td>
                  <td>{tipo.get('pessoa')}</td>
                  <td>{tipo.get('descricao')}</td>
                  <td>{DateUtils.formatDateTimeShort(tipo.get('inicio'))}</td>
                  <td>{DateUtils.formatDateTimeShort(tipo.get('termino'))}</td>
                  <td>{tipo.get('tipoContrato')}</td>
                  <td>{tipo.get('numeroContrato')}</td>
                  <td>{tipo.get('anoContrato')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    );
  }
}
